var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"building-info-list"},[_vm._l((_vm.infoList),function(item,index){return _c('buildingInfoCol',{key:item.name,attrs:{"showIndex":index,"info":item}})}),_c('div',{staticClass:"more",on:{"click":_vm.more}},[_c('div',[_vm._v("联系我们查看更多")]),_c('img',{attrs:{"src":require("@/assets/images/gateway/more.png")}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }